import React, { useEffect, useState } from "react";
import { useConnectWallet } from "../../hooks/useTxnClient";
import { walletState } from "../../context/walletState";
import { useRecoilValue } from "recoil";
import { useIBC } from "../../hooks/useIBC";
import { CoinButton } from "../common/buttons/CoinButton";
import Input from "../common/input/Input";
import GetBalance from "../common/balance/GetBalance";
import { useToken } from "../../hooks/useToken";
import { useSnip20Token } from "../../hooks/useSnip20Token";
import { coinConvert } from "../../utils/common";
import LoadingModal from "../common/loading-modal/LoadingModal";

const AssetUnwrap = ({ setIsModalOpen, assetToken, scrtLogo, setcheckRefresh }: any) => {
  const [active, setActive] = useState(false);
  const [text, setText] = useState("");
  const [sscrtBalance, setsScrtBalance] = useState<any>();
  const [ibcshortaddress, setibcshortaddress] = useState<any>();
  const [scrtBalance, setScrtBalance] = useState<any>();
  const [isLoading, setIsLoading]= useState(false);


  const { address, mediumAddress, balance } = useRecoilValue(walletState);
  const connectWallet = useConnectWallet();

  const token = useToken();
  const snipToken = useSnip20Token();

  const {
    getTokenScrtBalance,
    doToSourceTransfer,
    getTokenSourceAddressShort,
  } = useIBC();

  const handleUnWrap = async () => {
    // handle the Unwrap here
    setIsLoading(true);
    setcheckRefresh(false);
    const unwrapResponse = await snipToken.unWrapToken(
      // assetToken.display_denom,
      "sSCRT",
      text,
      );
      setIsLoading(false);
      setIsModalOpen(false);
      setcheckRefresh(true);
    console.log("unrapress", unwrapResponse);
  };

  useEffect(() => {
    const bala = async () => {
      const sBalance = await getTokenScrtBalance(assetToken.display_denom);
      setsScrtBalance(sBalance);

      const scrtBalance = coinConvert(balance?.amount as string, 6, "human");
      setScrtBalance(scrtBalance);

      const address = await getTokenSourceAddressShort(
        assetToken.display_denom
      );
      setibcshortaddress(address);
    };
    bala();
  }, [assetToken]);
  const [activeCoinBalance, setActiveCoinBalance] = useState<any>();
  const activeCoinBalanceHandler = (val: any) => {
    setActiveCoinBalance(val);
  };

  const str = assetToken.display_denom.slice(1);

  return (
    <>
      <div className="asset-withdraw asset_wrap">
        <div className="modal-header">
          <div className="asset-withdraw-header">Secret UnWrap</div>
          <div className="modal-close-wrapper">
            <span
              onClick={() => setIsModalOpen(false)}
              className="material-symbols-outlined modal-close-button"
            >
              close
            </span>
          </div>
        </div>
        <hr className="asset-hr-line"></hr>
        <div className="asset-wthdraw-img-container">
          <div>
            <span className="from-span">From</span>
            <div className="balance-wrapper">
              <CoinButton
                onClick={undefined}
                logoUrl={assetToken.logo_URIs.png}
                displayDenom={assetToken.display_denom}
                coinName={assetToken.name}
                showName={false}
              />
              <div className="deposit-amount">
                <input
                  type="number"
                  // placeholder="Enter the token amount"
                  value={text}
                  onChange={(e) => setText(e.target.value)}
                  placeholder="0.0000"
                  autoFocus={true}
                />
              </div>
            </div>
            <div className="icc-balance-wrapper from-span">
              <div className="wrapper-para wrap-css">In Wallet</div>:{" "}
              {!address ? (
                "-"
              ) : (
                <div>
                  <GetBalance
                    token={assetToken.display_denom}
                    fetchBal={activeCoinBalanceHandler}
                  />
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="asset-wthdraw-img-container">
          <div>
            <span className="from-span">To</span>
            <div className="balance-wrapper">
              <CoinButton
                onClick={undefined}
                logoUrl={assetToken.logo_URIs.png}
                displayDenom={str}
                coinName={assetToken.name}
                showName={false}
              />
              <div className="deposit-amount">
                <input
                  type="number"
                  // placeholder="Enter the token amount"
                  value={text}
                  onChange={(e) => setText(e.target.value)}
                  placeholder="0.0000"
                />
              </div>
            </div>
            <div className="icc-balance-wrapper from-span">
              <div className="wrapper-para wrap-css">In Wallet</div>:{" "}
              {!address ? (
                "-"
              ) : (
                <div>
                  {/* <GetBalance
                    token={'SCRT'}
                    fetchBal={activeCoinBalanceHandler}
                  /> */}
                  {scrtBalance}
                </div>
              )}
            </div>
          </div>
        </div>

        {/* <div className="deposit-time">
          <div>Fee Grant</div>
          <div className="fee-grant">Request Fee Grant</div>
        </div> */}

        <div
          className={`asset-withdraw-btn common-button ${
            sscrtBalance && address
              ? Number(sscrtBalance) < Number(text) || Number(text) <= 0
                ? "disabled-button"
                : ""
              : ""
          }`}
          onClick={
            address
              ? Number(sscrtBalance) >= Number(text) && Number(text) > 0
                ? handleUnWrap
                : () => {}
              : connectWallet
          }
        >
          {address
            ? !(Number(text) <= 0)
              ? !(Number(sscrtBalance) < Number(text))
                ? `UnWrap ${str}`
                : "Insufficient Balance"
              : "Invalid Input"
            : "Connect Wallet"}
        </div>

        <LoadingModal
        content={["Unwrapping token"]}
        isOpen={isLoading}
      />
      </div>
    </>
  );
};

export default AssetUnwrap;
